import { getLocalStorage } from './local-storage';

import { DEFAULT_UNIT_MEASUREMENT } from './constants';

export const getUnitMeasurement = () => {
  return getLocalStorage('unitMeasurement') || DEFAULT_UNIT_MEASUREMENT;
};

export const isImperialUnitMeasurement = () => {
  return getUnitMeasurement() === 'IMPERIAL';
};
